import Exports from "../../Pages/Mega/Exports";
import {
  ADD_EVENT_FAIL,
  ADD_EVENT_SUCCESS,
  GET_EVENTS_FAIL,
} from "../calendar/actionTypes";
import {
  ADD_IDQ_SUCCESS,
  DELETE_IDQ_SUCCESS,
  GET_IDQ_FAIL,
  GET_IDQ_SUCCESS,
  UPDATE_IDQ_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  ids: [],
  defective: [],
  exports: [],
  error: {},
};

const IDQ = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_IDQ_SUCCESS:
      return {
        ...state,
        ids: action.payload.apples,
        defective: action.payload.defective,
      };

    case GET_IDQ_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_IDQ_SUCCESS:
      return {
        ...state,
        ids: [...state.ids, action.payload],
      };

    case ADD_EVENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_IDQ_SUCCESS:
      return {
        ...state,
        ids: state.ids.map((id) =>
          id.id === action.payload.id ? { id, ...action.payload } : id
        ),
        isEventUpdated: true,
      };

    // case UPDATE_EVENT_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //     isEventUpdated: false,
    //   };

    case DELETE_IDQ_SUCCESS:
      return {
        ...state,
        ids: state.ids.filter((id) => id.id !== action.payload),
      };

    // case DELETE_EVENT_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //   };

    default:
      return state;
  }
};

export default IDQ;
